export default {
    name: 'CRMSettingsBranchAssociation'
};